/**
 * @generated SignedSource<<95103ea9d3873647a1045616956f785c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodosArchivedList_archiveTodos$data = {
  readonly archivedTodos: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly archivedAtDate: {
          readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
        } | null;
        readonly expireAtDate: {
          readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
        } | null;
        readonly id: string;
        readonly priority: TodoPriority;
        readonly publishedAtDate: {
          readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
        } | null;
        readonly title: string;
        readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoListItemDescription_todo" | "WorkspaceTodoListItemStatus_todo">;
      };
    }>;
  };
  readonly hasArchivedTodo: boolean;
  readonly id: string;
  readonly " $fragmentType": "WorkspaceTodosArchivedList_archiveTodos";
};
export type WorkspaceTodosArchivedList_archiveTodos$key = {
  readonly " $data"?: WorkspaceTodosArchivedList_archiveTodos$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodosArchivedList_archiveTodos">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "archivedTodos"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "FormattedDate"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "query"
    },
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./WorkspaceTodosArchivedList_WorkspaceRefetchQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "WorkspaceTodosArchivedList_archiveTodos",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasArchivedTodo",
      "storageKey": null
    },
    {
      "alias": "archivedTodos",
      "args": [
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query"
        }
      ],
      "concreteType": "TodoWorkspaceConnection",
      "kind": "LinkedField",
      "name": "__WorkspaceTodosArchivedList_archiveTodos_archivedTodos_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TodoWorkspaceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TodoWorkspace",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "priority",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UnzonedDate",
                  "kind": "LinkedField",
                  "name": "publishedAtDate",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UnzonedDate",
                  "kind": "LinkedField",
                  "name": "archivedAtDate",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UnzonedDate",
                  "kind": "LinkedField",
                  "name": "expireAtDate",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WorkspaceTodoListItemStatus_todo"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WorkspaceTodoListItemDescription_todo"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "d3bb36b98e22de9c27fb12cbe716f878";

export default node;
